import { CONFIG } from 'src/global-config';

// ----------------------------------------------------------------------
// Refresh silencioso da sessão do portal. A sessão vive em cookie httpOnly
// (portal_at / portal_rt), então o JS não lê o token — só chama /auth/refresh
// e o backend rotaciona o cookie de access. Usa `fetch` cru (não os axios do
// app) p/ não disparar interceptors/toasts nem recursão.
//
// Singleton in-flight: vários 401 concorrentes (SWR revalida N telas ao mesmo
// tempo) compartilham UM refresh; depois cada request original é reexecutado.
// ----------------------------------------------------------------------

let inFlight: Promise<boolean> | null = null;

export function refreshSession(): Promise<boolean> {
  if (!inFlight) {
    inFlight = fetch(`${CONFIG.serverUrl}/portal-api/auth/refresh`, {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: '{}',
    })
      // /auth/refresh agora responde 200 mesmo sem sessão (accessToken:null) p/
      // não poluir o console; "renovou" = veio um accessToken de fato.
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => !!d?.accessToken)
      .catch(() => false)
      .finally(() => {
        inFlight = null;
      });
  }
  return inFlight;
}

/** Manda pro login (hard nav) quando a sessão morreu — evita loop na própria /login. */
export function redirectToLogin() {
  const base = import.meta.env.BASE_URL || '/';
  if (!window.location.pathname.endsWith('/login')) {
    window.location.href = `${base}login`;
  }
}
